// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__uLt1p","Success":"Button_Success__-TGiT","Danger":"Button_Danger__9c5kB"};